import styled from '@emotion/styled'

import { breakpoints, palette, spacing, Text } from 'main/ui'

export const Container = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const ContentContainer = styled.div`
  height: 130px;
  width: 100%;

  border-radius: 3px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
  background: ${palette.white};
  @media (min-width: ${breakpoints.lg}px) {
    max-width: 100%;
  }
`

export const LeadStatusContainer = styled.div`
  background: ${palette.indigo};
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  padding: 0 ${spacing.majorScale(1)}px;
  white-space: nowrap;
`

export const LeadStatus = styled(Text)`
  color: ${palette.white};
  font-size: 13px;
`
